import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Wrapper, TabItem } from './styled';

const TabSwitcher = ({
  items,
  activeKey,
  onClick,
  maxW,
  isLink = false,
  itemWidth,
  width
}) => {
  return (
    <Wrapper maxW={maxW} width={width}>
      {items?.map((i) => (
        <TabItem
          as={isLink ? Link : undefined}
          key={i.id}
          active={activeKey === i.id}
          onClick={() => onClick && onClick(i.id)}
          to={i.to}
          w={itemWidth}
        >
          <span>{i.label}</span>
        </TabItem>
      ))}
    </Wrapper>
  );
};

TabSwitcher.propTypes = {
  items: PropTypes.array,
  activeKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  maxW: PropTypes.string,
  isLink: PropTypes.bool,
};

export default TabSwitcher;
